import { render } from "./AdoptionNotice.vue?vue&type=template&id=f19e5610&scoped=true"
import script from "./AdoptionNotice.vue?vue&type=script&lang=js"
export * from "./AdoptionNotice.vue?vue&type=script&lang=js"

import "./AdoptionNotice.vue?vue&type=style&index=0&id=f19e5610&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19e5610"]])

export default __exports__